import EkamAuthStateApp from './ekam.js';
export default EkamAuthStateApp;
